module.exports = __webpack_public_path__ + "media/images/membership-icon-109b7bd681893aa1968df550bb9bd034.svg";